/* eslint-env browser */
import * as PurchasesSDK from '@revenuecat/purchases-js'
import Smooch from 'smooch'

// webpack resolves this package to its UMD build, which registers itself on `window.Purchases`
// instead of populating the module exports (the ESM namespace comes back empty and named
// imports are `undefined`). Resolve from whichever shape is actually populated.
const RC =
  (PurchasesSDK && PurchasesSDK.Purchases && PurchasesSDK) ||
  (PurchasesSDK && PurchasesSDK.default && PurchasesSDK.default.Purchases && PurchasesSDK.default) ||
  (typeof window !== 'undefined' ? window.Purchases : null) ||
  {}
const { Purchases, ErrorCode } = RC

require('../../container/client')

const DOMHelper = require('../../client/clientjs/dom-helper')

// Maps the pricing-table plan (button data-rc-plan) to the RevenueCat package on the current offering.
const PACKAGE_GETTER_BY_PLAN = {
  monthly: offering => offering.monthly,
  quarterly: offering => offering.threeMonth,
  yearly: offering => offering.annual,
}

DOMHelper.onDocumentReady(() => {
  const rcOptions = window.rcOptions || {}
  const errorElt = DOMHelper.query('#error-message')
  const setError = msg => {
    if (errorElt) {
      errorElt.textContent = msg || ''
    }
  }

  // Fire the same conversion tracking the Chargebee success page did (Affilae + Facebook),
  // now on RevenueCat purchase success.
  const trackConversion = ({ amountEur, transactionId, plan, voucher }) => {
    try {
      if (rcOptions.affiliaeConfirmKey && amountEur != null) {
        let src =
          'https://lb.affilae.com/?key=' +
          encodeURIComponent(rcOptions.affiliaeConfirmKey) +
          '&id=' +
          encodeURIComponent(transactionId || '') +
          '&amount=' +
          encodeURIComponent(amountEur) +
          '&customer=' +
          encodeURIComponent(rcOptions.appUserId || '') +
          '&payment=online'
        if (voucher) {
          src += '&voucher=' + encodeURIComponent(voucher)
        }
        const iframe = document.createElement('iframe')
        iframe.src = src
        iframe.width = '1'
        iframe.height = '1'
        iframe.frameBorder = '0'
        iframe.style.display = 'none'
        document.body.appendChild(iframe)
      }
    } catch (e) {
      /* tracking must never block the flow */
    }
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Subscribe', {
          value: amountEur,
          coupon: voucher || '',
          currency: 'EUR',
          subscription_id: transactionId || '',
          plan_duration: plan,
        })
      }
    } catch (e) {
      /* noop */
    }
  }

  const purchases =
    rcOptions.publicKey && rcOptions.appUserId
      ? Purchases.configure({ apiKey: rcOptions.publicKey, appUserId: rcOptions.appUserId })
      : null

  DOMHelper.queryAll('button[data-rc-plan]').forEach(button => {
    button.addEventListener('click', async () => {
      if (!purchases) {
        return
      }
      const plan = DOMHelper.data(button, 'rc-plan')
      const getPackage = PACKAGE_GETTER_BY_PLAN[plan]
      setError('')
      button.classList.add('is-loading')
      try {
        const offerings = await purchases.getOfferings()
        // Production uses the current offering (live products); dev/staging overrides to the
        // sandbox "scale_test" offering via rcOptions.offeringId.
        const offering = rcOptions.offeringId ? offerings.all[rcOptions.offeringId] : offerings.current
        const rcPackage = offering && getPackage ? getPackage(offering) : null
        if (!rcPackage) {
          throw new Error(`No RevenueCat package for plan "${plan}"`)
        }

        const purchaseParams = {
          rcPackage,
          customerEmail: rcOptions.email || undefined,
          selectedLocale: rcOptions.locale || undefined,
          showDiscountCodeField: true,
          discountCode: rcOptions.discountCode || undefined,
        }
        // Carry the affiliate token onto the RC/Stripe transaction (Chargebee's cf_affiliate_id equivalent).
        if (rcOptions.affiliateToken) {
          purchaseParams.metadata = { affiliate_id: rcOptions.affiliateToken }
        }

        const result = await purchases.purchase(purchaseParams)
        const { customerInfo } = result

        if (customerInfo && customerInfo.entitlements.active.scale) {
          const price = rcPackage.webBillingProduct && rcPackage.webBillingProduct.currentPrice
          trackConversion({
            amountEur: price ? price.amountMicros / 1000000 : undefined,
            transactionId: result.storeTransaction && result.storeTransaction.storeTransactionId,
            plan,
            voucher: rcOptions.discountCode,
          })
          // Sync our backend immediately so premium shows without waiting for the webhook.
          await fetch('/api/users/me/syncRevenueCatSubscription', {
            method: 'POST',
            credentials: 'same-origin',
          })
          window.location.href = '/premium'
        }
      } catch (err) {
        // Swallow user cancellation, surface everything else.
        if (!(err && err.errorCode === ErrorCode.UserCancelledError)) {
          setError(rcOptions.errorText)
        }
      } finally {
        button.classList.remove('is-loading')
      }
    })
  })

  // Premium members with a RevenueCat subscription: turn the "manage subscription" text into a
  // link to the store/customer portal (Web Billing portal, App Store or Play Store as applicable).
  const manageElt = DOMHelper.query('[data-rc-manage]')
  if (purchases && manageElt) {
    purchases
      .getCustomerInfo()
      .then(info => {
        if (info && info.managementURL) {
          const link = document.createElement('a')
          link.href = info.managementURL
          link.target = '_blank'
          link.rel = 'noopener'
          link.textContent = manageElt.getAttribute('data-rc-manage-label') || manageElt.textContent
          manageElt.replaceWith(link)
        }
      })
      .catch(() => {})
  }

  Smooch.destroy()
  Smooch.init({
    appId: '56da9c0cb27ef129003ddf23',
  }).then(() => {
    Smooch.updateUser({
      userId: (window.initialState || {}).userId,
    })
  })
})

if (module.hot) {
  module.hot.accept()
}
